module.exports = __webpack_public_path__ + "static/media/shaolaishan_web.16f9e657.webp";